<template>
  <div>
    <a-row :gutter="[16, 16]">
      <a-col :xxl="6"
             :xl="7"
             :lg="12"
             :md="24"
             :sm="24"
             class="">
        <div style="display: flex; width: 100%; align-items: center; heigth: 100%">
          <div style="white-space: nowrap"
               class="row-label">所在区域：</div>
          <a-cascader :options="citySource"
                      @change="filterCity"
                      v-model="city"
                      changeOnSelect
                      placeholder="请选择所在区域"
                      class="row-item" />
        </div>
      </a-col>
      <a-col :xxl="6"
             :xl="7"
             :lg="12"
             :md="24"
             :sm="24"
             class="">
        <a-row type="flex">
          <div style="
              display: flex;
              width: 100%;
              align-items: center;
              heigth: 100%;
            ">
            <div style="white-space: nowrap"
                 class="row-label">网点名称：</div>
            <a-input v-model="filterParams.communityName"
                     placeholder="请输入所属网点名称"
                     allowClear
                     class="row-item" />
          </div>
        </a-row>
      </a-col>
      <a-col :xxl="6"
             :xl="7"
             :lg="12"
             :md="24"
             :sm="24"
             class=""
             style="">
        <div style="display: flex; width: 100%; align-items: center; heigth: 100%">
          <div style="white-space: nowrap"
               class="row-label">点位名称：</div>
          <a-input v-model="filterParams.deviceName"
                   allowClear
                   placeholder="请输入点位名称"
                   class="row-item" />
        </div>
      </a-col>
      <a-col :xxl="6"
             :xl="7"
             :lg="12"
             :md="24"
             :sm="24"
             class="">
        <div class="">
          <div style="
            display: flex;
            width: 100%;
            align-items: center;
            heigth: 100%;
            justify-content: ;
          ">
            <div style="white-space: nowrap"
                 class="row-label">MAC：</div>
            <a-input v-model="filterParams.mac"
                     allowClear
                     placeholder="请输入MAC"
                     class="row-item" />
          </div>
        </div>

      </a-col>
      <a-col :xxl="6"
             :xl="7"
             :lg="12"
             :md="24"
             :sm="24"
             class="">
        <div style="
            display: flex;
            width: 100%;
            align-items: center;
            heigth: 100%;
            justify-content: ;
          ">
          <a-button type="primary"
                    html-type="submit"
                    @click="handleSearch">查询</a-button>
          <a-button :style="{ marginLeft: '8px' }"
                    @click="handleReset">重置</a-button>
        </div>
      </a-col>
    </a-row>

  </div>
</template>
<script>
import api from '../../commomFun/api.js'
export default {
  data() {
    return {
      // 省市区下拉
      citySource: [],
      // 过滤参数
      filterParams: {
        deviceName: '',
        areaCode: '',
        communityName: '',
        mac: '',
      },
      city: [],
      modelType: [
        { text: 'QLG19-C215', value: '7' },
        { text: 'GWS19-49', value: '12' },
        { text: 'QLL19-C32', value: '13' },
        { text: 'QLG19-215', value: '14' },
        { text: 'QLL19-32', value: '15' },
        { text: 'QLG2020-R8', value: '17' },
      ],
    }
  },
  created() {
    this.getCityList()
  },
  methods: {
    // 城市模糊筛选
    filterCity(arr) {
      this.filterParams.areaCode = arr.length > 0 ? arr[arr.length - 1] : ''
    },
    handleSelectPub(val) {
      this.filterParams.publish = val
    },
    handleSelectDown(val) {
      this.filterParams.down = val
    },
    handleSelectDevic(val) {
      this.filterParams.onlineStatus = val
    },
    handleSelectModal(val) {
      this.filterParams.deviceModel = val
    },
    // 查询
    handleSearch() {
      this.$emit('callback', this.filterParams)
    },
    // 获取城市选择
    getCityList() {
      api.getApi('/machine/getAreaList').then((res) => {
        if (res.data.code == 200) {
          let areaList = []
          for (let firstKey of res.data.data) {
            let firstObj = {
              value: firstKey.key,
              label: firstKey.value,
              children: [],
            }
            for (let secondKey of firstKey.children) {
              let secondObj = {
                value: secondKey.key,
                label: secondKey.value,
                children: [],
              }
              for (let threeKey of secondKey.children) {
                secondObj.children.push({
                  value: threeKey.key,
                  label: threeKey.value,
                })
              }
              firstObj.children.push(secondObj)
            }
            areaList.push(firstObj)
          }

          this.citySource = areaList
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 重置 - 初始化数据
    handleReset() {
      let obj = {
        areaCode: '',
        communityName: '',
        deviceName: '',
        mac: '',
      }
      this.filterParams = obj
      this.city = []
      // 分页
      this.$emit('callback', this.filterParams)
    },
  },
}
</script>
<style lange="less" scoped>
.row-item {
  flex: 1;
  margin-bottom: 16px;
}
.row-label {
  width: 70px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
.ant-col-8 {
  height: 32px !important;
  margin-bottom: 16px !important;
}
.select-row {
  margin-top: 24px;
  height: 32px;
  display: flex;
  margin-bottom: 24px;
}
.select-row-first {
  margin-bottom: 16px;
}
.select-row-last {
  margin-top: 0px;
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-start;
  padding-left: 24px;
}
.row-select-item {
  margin-right: 32px;
  width: calc(33% - 16px);
}
</style>